import React from 'react';
import { Link } from 'react-router-dom';
import '../style/ServicesMenuStyles.css';

const HomePageServicesMenu = () => {
  const services = [
    {
      category: "Nail Services",
      items: [
        { name: "Regular Full Set", price: "$30" },
        { name: "Regular Fill", price: "$25" },
        { name: "Pink & White Solar Set", price: "$50" },
        { name: "Pink & White Fill", price: "$45" },
        
      ]
    },
    {
      category: "Pedicure & Manicure",
      items: [
        { name: "Regular Manicure", price: "$18" },
        { name: "Regular Pedicure", price: "$30" },
        { name: "Pedicure & Manicure Combo", price: "$47" },
        { name: "Paradise Tropical Manicure", price: "$27" }
      ]
    },
    {
      category: "Gel Nail Services",
      items: [
        { name: "Gel Color w/Manicure", price: "$35" },
        { name: "Gel French w/Manicure", price: "$40" },
        { name: "Gel Color w/O Manicure", price: "$22" },
        { name: "Gel French w/O Manicure", price: "$25" }
      ]
    }
  ];

  return (
    <div className="services-menu-container">
      <h2>Our Services Menu</h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-category">
            <h3>{service.category}</h3>
            <ul>
              {service.items.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <span className="service-name">{item.name}</span>
                  <span className="service-price">{item.price}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <Link to="/service" className="view-all-button">
        View All Services
      </Link>
    </div>
  );
};

export default HomePageServicesMenu;
